import { css } from '@emotion/react'
import { colors } from 'plume-ui'
import { ChangeEvent } from 'react'

type Props = {
  checked: boolean
  children: React.ReactNode
  onClick: (e: ChangeEvent) => void
}

export const CheckboxDropdownItem: React.FC<Props> = ({
  checked,
  children,
  onClick,
}) => {
  return (
    <li data-test-id="item">
      <Checkbox checked={checked} onChange={onClick}>
        {children}
      </Checkbox>
    </li>
  )
}

type CheckboxProps = {
  checked: boolean
  onChange: (e: ChangeEvent) => void
  children: React.ReactNode
}

const Checkbox: React.FC<CheckboxProps> = ({ checked, children, onChange }) => {
  return (
    <label
      css={css`
        display: flex;
        position: relative;
        cursor: pointer;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
        align-items: center;
        gap: 6px;
        padding: 0 12px 0 12px;
        :hover {
          background-color: #f1f1f1;
        }
        input[type='checkbox']:checked + span {
          background-color: ${colors.cyan50};
          border: 0;
        }
        input[type='checkbox']:checked + span:after {
          display: block;
        }
      `}
    >
      <span
        css={css`
          height: 16px;
          width: 16px;
          margin-right: 4px;
          ${checked
            ? 'background: #1F9DB8;'
            : `background: #ffffff; border: solid 1px ${colors.border};`}
          border-radius: 1px;
          box-sizing: border-box;
          position: relative;
        `}
      >
        {checked ? (
          <img
            className="check-icon"
            src="/static/icomoon/fonts/check.svg"
            alt=""
            css={css`
              position: absolute;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
            `}
          />
        ) : (
          <></>
        )}
      </span>
      <div
        className="parent-name-label"
        css={css`
          display: flex;
          align-items: center;
          height: 30px;
          list-style: none;
          color: rgb(102, 102, 102);
          line-height: 100%;
          width: calc(100% - 25px);
        `}
      >
        <div
          css={css`
            height: 20px;
            line-height: 1.5;
            max-width: 275px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          `}
        >
          {children}
        </div>
      </div>
      <input
        type="checkbox"
        checked={checked}
        onChange={onChange}
        css={css`
          display: none;
        `}
      />
    </label>
  )
}
